// extracted by mini-css-extract-plugin
module.exports = {"simple-text-form-group__input":"styles_simple-text-form-group__input__2FM-c","placeHolderShimmer":"styles_placeHolderShimmer__14Le5","shimmer":"styles_shimmer__3xG3I"};